import script from "./FirmwareCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./FirmwareCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./FirmwareCreateForm.vue?vue&type=style&index=0&id=3941218c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3941218c"]])

export default __exports__